import { PencilSquareIcon } from '@shared/assets/icons';
import { EditInvitingManagerModal } from '@features/clients';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { useState } from 'react';
import styles from './ManagersCell.module.scss';

interface ManagersCellProps {
  salesManager: string;
  invitingManager: string;
  onChangeInvitingManager: (value: string) => void;
}

export const ManagersCell = ({ salesManager, invitingManager, onChangeInvitingManager }: ManagersCellProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <div className={styles.container}>
        <UnstyledButton className={styles.editButton} onClick={handleOpenModal}>
          <span className={styles.editButtonContent}>
            <PencilSquareIcon size="16" color="currentColor" />
            Редактировать
          </span>
        </UnstyledButton>

        <div className={styles.managers}>
          <div className={styles.managerBlock}>
            <span className={styles.managerName}>{salesManager}</span>
            <span className={styles.managerLabel}>Менеджер по продажам</span>
          </div>
          <div className={styles.managerBlock}>
            <span className={styles.managerName}>{invitingManager}</span>
            <span className={styles.managerLabel}>Приглашающий менеджер</span>
          </div>
        </div>
      </div>

      <EditInvitingManagerModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSave={onChangeInvitingManager}
        salesManager={salesManager}
        invitingManager={invitingManager}
      />
    </>
  );
};
